import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import UserList, {MAROON} from '..';

const ClientList = ({clients, counterState}) => {
	const customItemRender = (item) => {
		const text = item?.label;

		const maxWidth = 'var(--px-400)';

		return (
			<OutputText ellipsis maxWidth={maxWidth} title={text}>
				{text}
			</OutputText>
		);
	};

	const props = {
		triggerVariant: MAROON,
		list: clients?.map(({name}) => name),
		singleLabel: labels.clientLabel,
		pluralLabel: labels.clientsLabel,
		customItemRender,
		counterState
	};

	return <UserList {...props} />;
};

ClientList.propTypes = {
	count: PropTypes.number
};

ClientList.defaultProps = {
	count: 0
};

export default ClientList;
